import { connect } from "react-redux";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { absolutePath } from "../../../../helpers/relativePath";
import { changeGroupStatus } from "../../../../reducers/groups/groupAction";
import {
  EDIT_GROUP,
  GROUP_CONTACT_PERSON_DETAIL_PAGE,
} from "../../../../helpers/routes";
import { KTSVG } from "../../../../../_metronic/helpers";
import StatusCell from "../../../commonComponent/table/StatusCell";
import UserActionsCell from "../../../commonComponent/table/UserActionsCell";

interface props {
  row: { Id: number; Name: string; IsActive: boolean };
  changeStatusDispatch: Function;
}

const GroupTableRow: FC<props> = ({ changeStatusDispatch, row }) => {
  const navigate = useNavigate();

  const editRecord = () => {
    navigate(absolutePath(`${EDIT_GROUP}/${row.Id}`));
  };

  const updateList = (id: number, callBack: Function) => {
    changeStatusDispatch(row.Id, callBack);
  };

  const viewContactperson = () => {
    navigate(absolutePath(`${GROUP_CONTACT_PERSON_DETAIL_PAGE}/${row.Id}`));
  };

  return (
    <tr>
      <td className="text-dark fw-bold ps-2">{row?.Name || "-"}</td>
      <td>
        <StatusCell isActive={row.IsActive} />
      </td>
      <td>
        <div className="d-flex gap-3 justify-content-end pe-5">
          <button
            className={`p-2 btn btn-icon btn-bg-light btn-sm btn-active-light-primary`}
            title="Edit"
            onClick={editRecord}
          >
            <KTSVG
              path="/media/icons/duotune/art/art005.svg"
              className="svg-icon-3"
            />
          </button>
          <UserActionsCell
            updateStatusDispatch={updateList}
            isActive={row?.IsActive}
            id={row?.Id}
          />
          <button
            className={`btn btn-active-light-primary btn-bg-light btn-sm fs-6 text-gray-600 text-hover-primary`}
            title="View Contact Person"
            onClick={viewContactperson}
          >
            View Contact Person
          </button>
        </div>
      </td>
    </tr>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    changeStatusDispatch: (groupId: number, successCallback: Function) =>
      dispatch(changeGroupStatus(groupId, successCallback)),
  };
};

export default connect(null, mapDispatchToProps)(GroupTableRow);
